import {
  DateRangeFilterValue,
  FilterDefinition,
  SelectFilterValue,
} from "./interfaces";

export function isFilterActive(
  type: FilterDefinition["type"],
  value: any,
): boolean {
  switch (type) {
    case "dateRange":
      const dateValue = value as DateRangeFilterValue;
      return (
        !!(dateValue?.range?.from && dateValue?.range?.to) ||
        !!dateValue?.relativeValue
      );

    case "select":
      const selectValue = value as SelectFilterValue;
      return Array.isArray(selectValue)
        ? selectValue.length > 0
        : selectValue !== null && selectValue !== undefined;

    case "boolean":
      return value === true;

    default:
      return false;
  }
}
